import { Button, Typography } from '@mui/material'
import { useNavigate } from '@tanstack/react-router'

export default function RbacAccessDeniedPage() {
  const navigate = useNavigate()

  return (
    <main className="flex min-h-screen items-center justify-center bg-sidebar px-6 py-10">
      <section className="w-full max-w-xl rounded-3xl border border-sidebar-border bg-background p-8 text-center shadow-xs">
        <Typography variant="h4" className="mb-3! font-semibold">
          Acces refuse
        </Typography>

        <Typography className="mb-6! text-muted-foreground">
          Votre compte n&apos;a pas la permission RBAC necessaire pour afficher cette page.
        </Typography>

        <Button variant="contained" onClick={() => navigate({ to: '/' })}>
          Retour a l&apos;accueil
        </Button>
      </section>
    </main>
  )
}
